"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUpdatedColumnTotals = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../base/constants");
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
var intersection_1 = tslib_1.__importDefault(require("lodash/intersection"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/sortBy"));
var uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
function getTotalsForMeasureAndType(totals, type, measureLocalIdentifier) {
    return totals.filter(function (total) { return total.measureIdentifier === measureLocalIdentifier && total.type === type; });
}
function getAttributeIntersection(totals, type, measureLocalIdentifiers) {
    var attributeGroups = measureLocalIdentifiers.map(function (measure) {
        var filteredTotals = getTotalsForMeasureAndType(totals, type, measure);
        return filteredTotals.map(function (total) { return total.attributeIdentifier; });
    });
    return intersection_1.default.apply(void 0, attributeGroups);
}
function getUniqueMeasures(totals, type) {
    var totalsOfType = totals.filter(function (total) { return total.type === type; });
    return uniq_1.default(totalsOfType.map(function (total) { return total.measureIdentifier; }));
}
function areMeasuresSame(measureLocalIdentifiers1, measureLocalIdentifiers2) {
    var sameMeasureLocalIdentifiers = intersection_1.default(measureLocalIdentifiers1, measureLocalIdentifiers2);
    return sameMeasureLocalIdentifiers.length === measureLocalIdentifiers2.length;
}
function getTotalsForAttributeHeader(totals, measureLocalIdentifiers) {
    return constants_1.AVAILABLE_TOTALS.reduce(function (columnTotals, type) {
        var uniqueMeasureLocalIdentifiers = getUniqueMeasures(totals, type);
        if (areMeasuresSame(uniqueMeasureLocalIdentifiers, measureLocalIdentifiers)) {
            var attributeLocalIdentifiers = getAttributeIntersection(totals, type, uniqueMeasureLocalIdentifiers);
            if (attributeLocalIdentifiers.length) {
                columnTotals.push({
                    type: type,
                    attributes: attributeLocalIdentifiers,
                });
            }
        }
        return columnTotals;
    }, []);
}
function getTotalsForMeasureHeader(totals, measureLocalIdentifier) {
    return totals.reduce(function (turnedOnAttributes, total) {
        if (total.measureIdentifier === measureLocalIdentifier) {
            var totalHeaderType = turnedOnAttributes.find(function (turned) { return turned.type === total.type; });
            if (totalHeaderType === undefined) {
                turnedOnAttributes.push({
                    type: total.type,
                    attributes: [total.attributeIdentifier],
                });
            }
            else {
                totalHeaderType.attributes.push(total.attributeIdentifier);
            }
        }
        return turnedOnAttributes;
    }, []);
}
function isTotalEnabledForAttribute(attributeLocalIdentifier, totalType, columnTotals) {
    return columnTotals.some(function (total) {
        return total.type === totalType && total.attributes.includes(attributeLocalIdentifier);
    });
}
function includeTotals(columnTotals, columnTotalsChanged) {
    var columnTotalsChangedUnique = columnTotalsChanged.filter(function (totalChanged) { return !columnTotals.some(function (total) { return isEqual_1.default(total, totalChanged); }); });
    return tslib_1.__spreadArrays(columnTotals, columnTotalsChangedUnique);
}
function excludeTotals(columnTotals, columnTotalsChanged) {
    return columnTotals.filter(function (total) { return !columnTotalsChanged.find(function (totalChanged) { return isEqual_1.default(totalChanged, total); }); });
}
function getUpdatedColumnTotals(columnTotals, menuAggregationClickConfig) {
    var type = menuAggregationClickConfig.type, measureIdentifiers = menuAggregationClickConfig.measureIdentifiers, attributeIdentifier = menuAggregationClickConfig.attributeIdentifier, include = menuAggregationClickConfig.include;
    var columnTotalsChanged = measureIdentifiers.map(function (measureIdentifier) { return ({
        type: type,
        measureIdentifier: measureIdentifier,
        attributeIdentifier: attributeIdentifier,
    }); });
    var updatedColumnTotals = include
        ? includeTotals(columnTotals, columnTotalsChanged)
        : excludeTotals(columnTotals, columnTotalsChanged);
    return sortBy_1.default(updatedColumnTotals, function (total) {
        return findIndex_1.default(constants_1.AVAILABLE_TOTALS, function (rankedItem) { return rankedItem === total.type; });
    });
}
exports.getUpdatedColumnTotals = getUpdatedColumnTotals;
exports.default = {
    getTotalsForAttributeHeader: getTotalsForAttributeHeader,
    getTotalsForMeasureHeader: getTotalsForMeasureHeader,
    isTotalEnabledForAttribute: isTotalEnabledForAttribute,
    getUpdatedColumnTotals: getUpdatedColumnTotals,
};
//# sourceMappingURL=aggregationsMenuHelper.js.map